import { render } from "./BookingRequestDetailPage.vue?vue&type=template&id=26438b85&scoped=true"
import script from "./BookingRequestDetailPage.vue?vue&type=script&lang=js"
export * from "./BookingRequestDetailPage.vue?vue&type=script&lang=js"

import "./BookingRequestDetailPage.vue?vue&type=style&index=0&id=26438b85&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-simba-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26438b85"]])

export default __exports__